window.ToolsCommon = (function () {
  // Safe float parse; returns null for blank/invalid input instead of NaN.
  function parseNumber(str) {
    if (str === '' || str === null || str === undefined) return null;
    var n = parseFloat(str);
    return isFinite(n) ? n : null;
  }

  // Solves C1V1 = C2V2 for whichever one of {c1, v1, c2, v2} is null.
  // The other three must be non-null finite numbers. Returns
  // { field: 'c1'|'v1'|'c2'|'v2', value: number }; throws Error on
  // over/under-determined input or a non-finite/negative result.
  function solveDilution(inputs) {
    var keys = ['c1', 'v1', 'c2', 'v2'];
    var missing = keys.filter(function (k) { return inputs[k] === null; });
    if (missing.length !== 1) {
      throw new Error('Enter exactly three of the four values and leave one blank to solve for it.');
    }
    var target = missing[0];
    var c1 = inputs.c1, v1 = inputs.v1, c2 = inputs.c2, v2 = inputs.v2;
    var value;
    if (target === 'c1') value = (c2 * v2) / v1;
    if (target === 'v1') value = (c2 * v2) / c1;
    if (target === 'c2') value = (c1 * v1) / v2;
    if (target === 'v2') value = (c1 * v1) / c2;
    if (!isFinite(value) || value < 0) {
      throw new Error('These inputs produce an invalid result. Check for a zero value in the denominator.');
    }
    return { field: target, value: value };
  }

  // Generic single-field validator: toggles .is-invalid on the field.
  // opts: { required: bool, min: number, max: number }
  function validateField(fieldEl, opts) {
    opts = opts || {};
    var raw = fieldEl.value.trim();
    var num = parseNumber(raw);
    var valid = true;

    if (opts.required && raw === '') valid = false;
    if (raw !== '' && num === null) valid = false;
    if (num !== null && opts.min !== undefined && num < opts.min) valid = false;
    if (num !== null && opts.max !== undefined && num > opts.max) valid = false;

    fieldEl.classList.toggle('is-invalid', !valid);
    return valid;
  }

  // Fills a shared .result-box element with a success/error message.
  function showResult(boxEl, status, html) {
    boxEl.className = 'result-box is-visible ' + status;
    boxEl.innerHTML = html;
  }

  // Rounds to a number of significant figures and trims trailing zeros.
  function formatSig(num, sigFigs) {
    if (!isFinite(num)) return '—';
    return Number(num.toPrecision(sigFigs || 4)).toString();
  }

  return {
    parseNumber: parseNumber,
    solveDilution: solveDilution,
    validateField: validateField,
    showResult: showResult,
    formatSig: formatSig
  };
})();
